var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["category-secondary-content-slot.j2"] = require( "category-secondary-content-slot.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/collections-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/collections-component.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
if(t_1.hasOwnProperty("imageUrl")) {
var t_5 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_5);
env.getTemplate("category-secondary-content-slot.j2", false, "core/templates/contentful/collections-component.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n<div class=\"c-home-collections\">\n\n    <div class=\"o-row o-column o-extra-small--12\">\n\n        <a href=\"";
output += runtime.suppressValue((lineno = 9, colno = 29, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"slug")])), env.opts.autoescape);
output += "\">\n            <picture>\n\n                <source srcset=\"";
output += runtime.suppressValue((lineno = 12, colno = 41, runtime.callWrap(t_5, "imageUrl", context, [])), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"slug"), env.opts.autoescape);
output += "-LARGE?wid=1150\" media=\"(min-width: 768px)\">\n\n                <img class=\"c-home-collections__image\" src=\"";
output += runtime.suppressValue((lineno = 14, colno = 69, runtime.callWrap(t_5, "imageUrl", context, [])), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"slug"), env.opts.autoescape);
output += "?wid=707\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"displayName"), env.opts.autoescape);
output += "\" />\n\n            </picture>\n        </a>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--8 u-no-gutters c-home-collections__text-container\">\n\n                <h2 class=\"c-home-collections__h2\">\n                    <a class=\"c-home-collections__a c-home-collections__a--header\" href=\"";
output += runtime.suppressValue((lineno = 24, colno = 101, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"slug")])), env.opts.autoescape);
output += "\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"displayName"), env.opts.autoescape);
output += "\n                    </a>\n                </h2>\n\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"salePrice")) {
output += "\n\n                <p class=\"c-home-collections__p\">\n                    <span class=\"c-product-meta__current-price c-product-meta__current-price--sale\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"salePrice"), env.opts.autoescape);
output += "\n                    </span>\n\n                    <span class=\"c-product-meta__original-price\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"listPrice"), env.opts.autoescape);
output += "\n                    </span>\n                </p>\n\n                ";
;
}
else {
output += "\n\n                <p class=\"c-home-collections__p\">\n                    <span class=\"c-product-meta__current-price\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"listPrice"), env.opts.autoescape);
output += "\n                    </span>\n                </p>\n\n                ";
;
}
output += "\n\n                <p class=\"c-home-collections__p c-home-collections__p--fabric-details\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"fabricDetails"), env.opts.autoescape);
output += "\n                </p>\n\n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-medium--4 u-no-gutters c-home-collections__text-container c-home-collections__text-container--cta\">\n\n                <a class=\"c-home-collections__a c-home-collections__a--cta\" href=\"";
output += runtime.suppressValue((lineno = 59, colno = 94, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"slug")])), env.opts.autoescape);
output += "\">\n                    ";
output += runtime.suppressValue((lineno = 60, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["collections_view-full-collection"])), env.opts.autoescape);
output += "\n                </a>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/collections-component.j2"] , dependencies)